import { render } from "./dispatch-indicators.vue?vue&type=template&id=0096aca4&scoped=true&ts=true"
import script from "./dispatch-indicators.ts?vue&type=script&lang=ts"
export * from "./dispatch-indicators.ts?vue&type=script&lang=ts"

import "./dispatch-indicators.scss?vue&type=style&index=0&id=0096aca4&lang=scss&scoped=true"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0096aca4"]])

export default __exports__